/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {GlobalGroupChooser} from '@ion/dls/src/components/groupchooser/GlobalGroupChooser';
import {groupChooserSelector} from '@/store/selectors/global-group';
import {setGlobalGroup, showChangeGroup} from '../store/actions/global-group-chooser';

/**
 * @GlobalAccountChooserDrawer
 * It will display GlobalAccountChooserDrawer
 * ```typescript
 *   import GlobalAccountChooserDrawer from '@ion/packages/ion-ctc-admin/src/header/GlobalAccountChooserDrawer';
 *
 *   <GlobalAccountChooserDrawer />;
 *
 * ```
 */
export const GlobalAccountChooserDrawer = () => {
  const dispatch = useDispatch();
  const {
    accountHierarchy,
    globalGroup,
    groupChooser : {
      isViewing: openChooser
    }
  } = useSelector(groupChooserSelector);

  const onClick = useCallback(function() {
    dispatch(showChangeGroup(!openChooser));
  }, [openChooser]);

  const onCloseDrawer = useCallback(function() {
    dispatch(showChangeGroup(false));
  }, []);

  const selectGroup = useCallback(function(group) {
    dispatch(setGlobalGroup(group));
  }, []);

  return (
    <GlobalGroupChooser allCrumbsClickable
      accountHierarchy={accountHierarchy}
      selectedGroup={globalGroup}
      drawerOpen={openChooser}
      onDrawerClick={onClick}
      onCloseDrawer={onCloseDrawer}
      onSelectGroup={selectGroup}
      hideParentAccount
      includeSelectedAccountId
      includeBreadcrumbs
      disableAutoSelect />
  );
};

export default React.memo(GlobalAccountChooserDrawer);
